import { HeatmapWidgetWrapper } from '../../heatmap-widget/HeatmapWidget';
import type { HeatmapWidgetEntity } from '../../heatmap-widget/HeatmapWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderHeatmapWidget(widget: HeatmapWidgetEntity, options: TWidgetRendererOptions): TRenderWidget {
  return () => <HeatmapWidgetWrapper entity={widget} options={options} />;
}
